import { deleteMethod, postMethod, putMethod } from "../../../store/api/CommonFunctions";

const BASE_URL = "api/WorkItemActivitiesAPI";

export const create = async (data) => {
    const result = await postMethod(`${BASE_URL}/Create`, data, "Create");
    if (result.Message) {
        const errorResult = { Error: result.Message };
        return errorResult;
    }
    return result;
}
export const update = async (data) => {
    const result = await putMethod(`${BASE_URL}/Update`, data, "Update");
    if (result.Message) {
        const errorResult = { Error: result.Message };
        return errorResult;
    }
    return result;
}
export const deleteActivity = async (id) => {
    const result = await deleteMethod(`${BASE_URL}/Delete?id=${id}`, "Delete");
    if (result.Message) {
        const errorResult = { Error: result.Message };
        return errorResult;
    }
    return result;
}